import { getCommonStyle } from '../styleCommon';
import { shapeType } from '../../enums/indicators/price';

export function getPriceStyles() {

	const commonPrimaryColor = getCommonStyle('color.primary');
	const commonNegativeColor = getCommonStyle('color.negative');
	const commonNeutralColor = getCommonStyle('color.neutral');
	const commonPositiveColor = getCommonStyle('color.positive');
	const commonLineWidth = getCommonStyle('line.width');

	return {
		background: {
			color: commonPrimaryColor,
			colorStop: 'rgba(255, 255, 255, 0.4)'
		},
		bar: {
			color: commonPrimaryColor
		},
		candlestick: {
			negative: {
				color: getCommonStyle('color.negative')
			},
			neutral: {
				color: commonNeutralColor
			},
			positive: {
				color: getCommonStyle('color.positive')
			},
			line: {
				default: {
					width: 1
				},
				large: {
					width: 1.5
				}
			},
			size: {
				large: false
			}
		},
		color: commonPrimaryColor,
		lineDash: null,
		ohlc: {
			negative: {
				color: commonNegativeColor
			},
			neutral: {
				color: commonNeutralColor
			},
			positive: {
				color: commonPositiveColor
			},
			line: {
				default: {
					width: 1
				},
				large: {
					width: 1.5
				}
			},
			size: {
				large: false
			}
		},
		palette: [
			'#ea580c', // orange
			'#16a34a', // green
			'#a855f7', // purple
			'#3b82f6', // blue
			'#ec4899', // pink
			'#eab308' // dark yellow
		],
		posneg: {
			lineDash: null,
			negative: {
				background: {
					color: 'rgba(178, 0, 0, 0.1)',
					colorStop: null
				},
				color: commonNegativeColor
			},
			positive: {
				background: {
					color: 'rgba(17, 182, 0, 0.1)',
					colorStop: null
				},
				color: commonPositiveColor
			},
			width: commonLineWidth
		},
		shape: {
			background: {
				color: commonPrimaryColor
			},
			color: commonPrimaryColor,
			length: 7,
			offset: 2,
			type: shapeType.CIRCLE,
			width: 1.5
		},
		width: commonLineWidth
	};
}
